import clsx from "clsx";

import { FCC } from "@/types";

type Styles = {
  link?: string;
  text?: string;
};

type Props = {
  customStyles?: Styles;
  external?: boolean;
  href: string;
  label: string;
};

/**
 * LinkOption - Simple link component for dropdown menus
 * Provides external link handling and custom styling
 */
export const LinkOption: FCC<Props> = ({
  href,
  label,
  external = true,
  customStyles,
}) => {
  return (
    <a
      href={href}
      className={clsx(
        "font-small mb-4 flex w-full justify-between text-left hover:font-semibold hover:underline md:mb-2",
        customStyles?.link,
      )}
      target={external ? "_blank" : undefined}
      rel={external ? "noreferrer noopener" : undefined}
    >
      <span className={customStyles?.text}>{label}</span>
    </a>
  );
};
